
<!-- TO DO：发布生产前需要把该判断 加上 !canUsePortal -->
<!-- <div class="home-carousel-container" *ngIf="!isHomeBak">
  <img src="assets/images/no-login-banner1.png" [ngStyle]="carouselImageStyle()" alt="">
</div> -->

<div class="home-carousel-container" *ngIf="!isHomeBak">
  <nz-carousel nzAutoPlay *ngIf="carouselList && carouselList?.length">
    <div 
      nz-carousel-content 
      *ngFor="let item of carouselList">
      <div class="flex justify-center"  [ngStyle]="carouselImageWH">
        <img [src]="item.imageBase64" (load)="handleImageLoad(item)"  />
      </div>
    </div>
  </nz-carousel>
  <div *ngIf="!carouselList?.length">
    <img src="assets/images/banner_default.jpg"  [ngStyle]="carouselImageWH" />
  </div>
</div>


<!-- login success -->
<dealer-portal-home *ngIf="canUsePortal && isHomeBak"></dealer-portal-home>

